import { ReactElement } from 'react'
import { DropdownWrapper, EditableDropdown, FlexWrapper, Input } from '../../../components'
import { DropdownListProps } from '../../../components/EditableDropdown/typings'
import { Lessonstatus } from './const'
import DatePicker from 'react-datepicker'
import { format } from 'date-fns'
import { DATE_FORMAT_YYYYMMDD } from '../../../const/dateFormat'

interface LessonProps {
    values: any
    setValues: any
}

const LessonUpdate = ({ values, setValues }: LessonProps): ReactElement => {
    return (
        <FlexWrapper justifyContent='center'>
            <DropdownWrapper width='50%'>
                <EditableDropdown
                    title='Status'
                    dropdownList={Lessonstatus}
                    handleSelect={(item: DropdownListProps) => {
                        setValues({
                            ...values,
                            status: item?.name
                        })
                    }}
                    placeholder={'Select Status'}
                />
            </DropdownWrapper>
            <DropdownWrapper width='50%'>
                <DatePicker
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={values?.date ? new Date(values?.date) : new Date()}
                    onSelect={(datees: Date) =>
                        setValues({
                            ...values,
                            date: datees ? format(datees, DATE_FORMAT_YYYYMMDD) : ''
                        })
                    }
                    onChange={(datees: Date) => {
                        setValues({
                            ...values,
                            date: datees ? format(datees, DATE_FORMAT_YYYYMMDD) : ''
                        })
                    }
                    }
                    placeholderText={'Date'}
                    customInput={
                        <Input
                            value={values?.date}
                            label={'Select Date'}
                            placeholder={'Date'}
                            height="50px"
                            suffix={['far', 'calendar']}
                            onChange={(value: string) => {
                                setValues({
                                    ...values,
                                    date: value
                                })
                            }}
                        />
                    }
                />
            </DropdownWrapper>
        </FlexWrapper>
    )
}

export default LessonUpdate